import React, { useState,useRef, useEffect } from 'react';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import PrintIcon from '@material-ui/icons/Print';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HomeIcon from '@material-ui/icons/Home';
import CancelIcon from '@material-ui/icons/Cancel';
import Grid from '@material-ui/core/Grid';
import MaterialTable from "material-table";
import {TableIcons as tableIcons} from "../../../Elemnts/TableIcons";

import { useHistory } from 'react-router-dom';

// sty
import {useStylesSpDial} from '../../../St/Reviews/UseStyle';
import {stElemnt} from '../../../St/Reviews/cStyle';

import ButtonGroup from '@material-ui/core/ButtonGroup';
import PrintCashairCon from './PrintCashairCon';

const iInfo = JSON.parse(localStorage.getItem('iInfos')) || {};

class ComponentToPrint extends React.Component {
  state = {} 
  constructor(){ super(); }

  render() {
    const locInv = JSON.parse(localStorage.getItem('premiApp')) || {};

    const styleCont = {
     backgroundColor: '#fff',
   };
   
       const styleTyg = { 
         backgroundColor: '#fff', 
         color :'#000',
           padding:'0.2mm' 
         };
    return (
        <Grid item container justifyContent='center' style={styleCont}> 
        <Grid item 
        style={{
          width:locInv.cachirWidth<80?"85mm":`${locInv.cachirWidth}mm`,
          backgroundColor:'#fff'
        }}
        > 
        <CssBaseline />
          <Typography component="div" style={styleTyg}>
  
          <PrintCashairCon onUnmountComplete={this.props?.onUnmountComplete} />
       
         </Typography>
        </Grid> 
        </Grid> 
        
      );
  }
}


const PrintInvCashair = () => {
  const componentRef = useRef();
  const clasSp = useStylesSpDial();

  const [open, setOpen] = useState(true);
  const [isPrint, setIsprint] = useState(false);


  const handleOpen = () => { setOpen(true); };
  const handleClose = () => { setOpen(true); };
 
  let his = useHistory();

  const back = (path) => {
    path ? his.push({ pathname: "/" }) : his.goBack();
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  onAfterPrint: () => back(false),
  });
  const [childMountCount, setChildMountCount] = useState(0);
  const handleChildMountComplete = () => {
    setChildMountCount((prevCount) => prevCount + 1);
  };
   useEffect(() => {
    console.log(childMountCount);
    if (childMountCount === 3) {
      setTimeout(async () => {
        handlePrint();
      }, 500);
    }
  }, [childMountCount]);

  const actions = [
    { icon: <ReactToPrint trigger={() => <PrintIcon /> } content={() => componentRef.current} />, name: 'طباعـة' },
    { icon: <ArrowBackIcon className={clasSp.ico} onClick={()=> back(false)}  />, name: 'رجـوع' },
  ];

  return (
    <div className={clasSp.root2}>
      <ComponentToPrint
        ref={componentRef}
        onUnmountComplete={handleChildMountComplete}
      />
      <SpeedDial ariaLabel="SpeedDial openIcon example"
        className={clasSp.speedDial} hidden={false}
        icon={<SpeedDialIcon openIcon={<HomeIcon />} onClick={()=> back(true)} />}
        onClose={handleClose} onOpen={handleOpen} open={open}>
        {actions.map((action,i) => ( <SpeedDialAction key={i}
         icon={action.icon} tooltipTitle={action.name} onClick={handleClose} />))}
      </SpeedDial>
    </div>
  );
};


export default PrintInvCashair


